import './error_boundary.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorInfo: null
    };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any child components and re-renders with an error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    const { shouldSuggestReporting } = this.props;

    if (this.state.error) {
      
      // Fallback UI if an error occurs
      return (
        <div className="error-boundary">
          <h2>Oh no—something went wrong!</h2>
          <p>
            An error was encountered. You will probably need to refresh this site
            to get things working again.
          </p>
          {
            shouldSuggestReporting &&
            <p>
              Please help make Zoomforth better by reporting what you were doing 
              when this error occurred, as well as the following information to the
              Zoomforth support team:
            </p>
          }
          <h3>Error</h3>
          <textarea 
            readOnly
            value={this.state.error && this.state.error.toString()}
            onFocus={(e)=> {
              e.target.select();
            }}
          />
          <h3>Component Stack Trace</h3>
          <textarea 
            readOnly
            style={{height:300}}
            value={this.state.errorInfo.componentStack} 
            onFocus={(e)=> {
              e.target.select();
            }}
          />
        </div>
      );
    }
    // component normally just renders children
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  shouldSuggestReporting: PropTypes.bool
};
ErrorBoundary.defaultProps = {
  shouldSuggestReporting: false
};


export const withWrappingErrorBoundary = (Component)=> {
  const ComponentWrappedWithErrorBoundary = (props)=>
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>;
  ComponentWrappedWithErrorBoundary.displayName = `${Component.displayName || Component.name}WrappedInErrorBoundary`;
  return ComponentWrappedWithErrorBoundary;
};

export default ErrorBoundary;
